import { BREAKPOINTS, COLORS, InputChip } from "@laerdal/life-react-components";
import styled from "styled-components";

export const ContentContainer = styled.div`
  width: 100%;
  max-width: ${1600 + 2 * 32}px;
  margin: 0 auto;
  padding: 0 32px;
  box-sizing: border-box;

  ${BREAKPOINTS.MEDIUM}{
    max-width: ${1600 + 2 * 38}px;
    padding: 0 38px;
  }
  ${BREAKPOINTS.LARGE}{
    max-width: ${1600 + 2 * 64}px;
    padding: 0 64px;
  }
`;

export const HeaderContainer = styled.div`
  background: ${COLORS.neutral_20} ;
  
  border-bottom: 1px solid var(--life-color-border-subtle);
  border-top: 1px solid var(--life-color-border-subtle);
  margin-bottom:16px;
  
  display: flex;
  flex-direction: column;
  
  width: 100%;

  ${BREAKPOINTS.LARGE}{
    margin-bottom: 64px;
  }
`;

export const Search = styled.div`
  padding: 32px 0;
  width: 100%;
`;

export const TopFrame = styled.div`
  flex-grow: 1;  

  z-index: 1;
  display: flex;
  flex-direction: column;
  align-self: center;
  
  flex-shrink: 0;
`;

export const BreadcrumbFrame = styled.div`
  margin:32px auto;
  flex-grow: 0;  

  z-index: 1;
  display: flex;
  flex-direction: column;
  align-self: center;
  
  flex-shrink: 0;
`;

export const SearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const PaginatorContainer = styled.div`
  display: flex;
  justify-content: center;

  li{
    width:40px !important;
  }
`;

export const ArticleContainers = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  row-gap: 32px;
`;

export const ArticlePage = styled.div`
  margin: 0 auto 50px;
`;

export const NoResults = styled.div`
  border-radius: 8px;
  background: ${COLORS.neutral_20};
  display: flex;
  padding: 16px 32px;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
`;

export const NoResultsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const Article = styled.div`
  display: flex;
  flex-direction: column;
  gap:8px;
`;

export const ShowingLabel = styled.div`
  color: ${COLORS.neutral_600};
  font-feature-settings: 'liga' off;
  /* Components/Regular/S */
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 125% */
  margin-bottom: -22px;
  display: none;
  ${BREAKPOINTS.LARGE}{
    display: block;
  }
`;

export const MobileShowingLabel = styled.div`
  color: ${COLORS.neutral_600};
  font-feature-settings: 'liga' off;
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 14px;
  ${BREAKPOINTS.LARGE}{
    display: none;
  }
`;

export const ArticleDescription = styled.div`
  color: var(--life-color-text-subtle);
  font-feature-settings: 'liga' off;
  /* Components/Regular/S */
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 125% */
  overflow-wrap: break-word;
  word-break: break-all;
`;

export const ArticleMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
  color: var(--life-color-text-subtle);
  font-feature-settings: 'liga' off;
  font-family: Lato;
  font-size: 12px;
  font-style: italic;
  font-weight: 400;
  line-height: 16px;

  svg {
    width: 4px;
    height: 4px;
  }
`;

export const Breadcrumb = styled.div`
  padding: 24px 0;

  ${BREAKPOINTS.MEDIUM}{
    padding: 24px 0;
  }
  ${BREAKPOINTS.LARGE}{
    padding: 32px 0;
  }
`;

export const CrumbLink = styled.a`
  &:link, &:visited, &:hover, &:active {
    color: ${COLORS.primary_600};
    text-decoration: none; 
  }

  color: ${COLORS.primary_600};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 25px; 
`;

export const CrumbText = styled.span`
  color: ${COLORS.neutral_500};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 25px; 
`;

export const Devider = styled.span`
  padding: 0 10px;
  color: ${COLORS.neutral_500};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 25px; 
`;

export const Answer = styled.div`
  margin-top: 16px;
`;

export const ResultsLayout = styled.div`
  display: flex;
  gap: 32px;
`;

export const DesktopFilterSidebar = styled.div`
  display: none;
  ${BREAKPOINTS.LARGE}{
    display: flex;
    width: 300px;
    flex-shrink: 0;
    flex-direction: column;
    gap: 24px;
    padding-top: 20px;
  }
`;

export const ResultsContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const MobileFilterChip = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
  ${BREAKPOINTS.LARGE}{
    display: none;
  }
`;

export const FilterOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: white;
  z-index: 1000;
  overflow-y: auto;
  padding: 24px;
  display: flex;
  flex-direction: column;
`;

export const FilterOverlayContent = styled.div`
  flex: 1;
  overflow-y: auto;
`;

export const FilterOverlayFooter = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding-top: 16px;
  border-top: 1px solid ${COLORS.neutral_100};
`;

export const FilterOverlayHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const DesktopFilterHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DesktopFilterLabel = styled.span`
  color: ${COLORS.accent1_700};
  font-family: Lato;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
`;

export const StyledInputChip = styled(InputChip)`
  border: 0;
  &&.default > div > div {
    color: ${COLORS.primary_600} !important;
    background-color: ${COLORS.primary_50} !important;
    border: 0;
  }
`;
